export default function PaddleDuelIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M32 6v52" stroke="#3B434F" strokeWidth="3" strokeDasharray="5 5" />
      <rect x="8" y="14" width="7" height="22" rx="3" fill="#2F8BFF" />
      <rect x="49" y="28" width="7" height="22" rx="3" fill="#FF8A1F" />
      <circle cx="38" cy="22" r="5" fill="#E7ECF3" />
      <path d="M33 25 L20 31" stroke="#E7ECF3" strokeOpacity="0.4" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
